<div class="complaint-position">
    <div *ngIf="b2cForm" class="position-header">
        <div class="title">
            {{ index + 1 }}. {{ complaintPosition.complaintProductType ? complaintPosition.complaintProductType : ('COMPLAINT|Nie wybrano typu produktu' | translate) }}
        </div>
        <div class="actions">
            <button
                *ngIf="positionsCount > 1"
                iccButton
                appearance="outline"
                (click)="remove()"
            >
                <icc-icon name="delete"></icc-icon> {{ 'COMPLAINT|Usuń usterkę' | translate}}
            </button>

            <button
                type="button"
                iccButton
                appearance="outline"
                (click)="switchShowDetails(!showDetails)"
            >
                <icc-icon
                    *ngIf="showDetails"
                    name="compress"
                ></icc-icon>

                <icc-icon
                    *ngIf="!showDetails"
                    name="expand"
                ></icc-icon>

            </button>
        </div>
    </div>
    <ng-container *ngIf="showDetails">
        <div class="complaint-position__flex-container" [class.b2c-form]="b2cForm">
            <div class="complaint-position__select" [style.width]="complaintPosition.complaintProductTypeId ? '100%' : '50%'">
                <icc-select
                    [value]="complaintPosition.complaintProductTypeId"
                    [label]="'COMPLAINT|Typ produktu' | translate"
                    id="complaintProductType"
                    (valueChange)="onComplaintProductTypeChange($event)"
                    size="medium"
                    [required]="true"
                    [prefixIcon]="'configure'"
                    appearance="outline"
                >
                    <option
                        *ngFor='let complaintProductType of data.complaintProductTypes'
                        [value]="complaintProductType.id"
                        [selected]="complaintProductType.id === complaintPosition.complaintProductTypeId"
                    >
                        {{ complaintProductType.name }}
                    </option>
                </icc-select>
                <icc-icon *ngIf="complaintPosition.complaintProductTypeId"></icc-icon>
            </div>
            <div class="complaint-position__select" *ngIf="complaintPosition.complaintProductTypeId">
                <icc-select
                    [value]="complaintPosition.complaintDocumentType"
                    [label]="'COMPLAINT|Typ dokumentu' | translate"
                    (valueChange)="onComplaintDocumentTypeChange($event)"
                    size="medium"
                    [required]="true"
                    [prefixIcon]="'control'"
                >
                    <option
                        *ngFor='let defectDocumentType of data.defectDocumentTypes | keyvalue'
                        [value]="defectDocumentType.key"
                        [selected]="defectDocumentType.key === complaintPosition.complaintDocumentType"
                    >
                        {{ defectDocumentType.value }}
                    </option>
                </icc-select>
                <icc-icon *ngIf="complaintPosition.complaintProductTypeId"></icc-icon>
            </div>
        </div>
        <div *ngIf="showFields.serialNumber" class="complaint-position__input">
            <icc-input
                type="text"
                [name]="'serialNumber'"
                [value]="complaintPosition.serialNumber"
                [size]="'medium'"
                (valueChange)="complaintPosition.serialNumber = $event; validateSerialNumber($event)"
                [placeholder]="'COMPLAINT|Numer seryjny produktu' | translate"
                [label]="'COMPLAINT|Numer seryjny produktu' | translate"
                [prefixIcon]="'control'"
                [required]="isB2bComplaintForm && complaintPosition.complaintDocumentType === 'serialNumber'"
                [supportText]="!complaintPosition.serialNumber?.length ? (complaint.authorizedRetailerCompanyId !== null && !isB2bComplaintForm) ? ('COMPLAINT|Przyjęcie zgłoszenia wymaga jednoznacznej identyfikacji zamówienia lub produktu (nr seryjny, nr zamówienia lub nr faktury zakupu), dla zakwalifikowania jako zgłoszenie reklamacyjne. Jeśli dane nie zostaną podane lub zostaną podane błędnie postaramy się odnaleźć zamówienie, jednak może to wydłużyć proces lub uniemożliwić przekazanie zgłoszenia do realizacji. W takiej sytuacji poinformujemy o tym w wiadomości email lub telefonicznie.' | translate) : ('COMPLAINT|Przyjęcie zgłoszenia wymaga jednoznacznej identyfikacji zamówienia lub produktu (nr seryjny lub nr zamówienia), dla zakwalifikowania jako zgłoszenie reklamacyjne. Jeśli dane nie zostaną podane lub zostaną podane błędnie, zgłoszenie nie zostanie przyjęte.' | translate) : !complaintPosition.invalidSerialNumber && b2cForm ? ('COMPLAINT|Weryfikacja podanego numeru zostanie przeprowadzona po potwierdzeniu adresu email zgłaszającego' | translate) : null"
                [errorMessage]="complaintPosition.invalidSerialNumber ? ('COMPLAINT|Podany numer seryjny jest nieprawidłowy' | translate) : null"
            ></icc-input>
            <icc-icon *ngIf="complaintPosition.complaintProductTypeId" name="info" (click)="openInfo('serialNumber')"></icc-icon>
        </div>
        <div *ngIf="showFields.invoiceNumber" class="complaint-position__input">
            <icc-input
                type="text"
                [name]="'invoiceNumber'"
                [value]="complaintPosition.invoiceNumber"
                [size]="'medium'"
                (valueChange)="complaintPosition.invoiceNumber = $event"
                [placeholder]="'COMPLAINT|Nr faktury' | translate"
                [label]="'COMPLAINT|Nr faktury' | translate"
                [prefixIcon]="'control'"
                [supportText]="!complaintPosition.invoiceNumber?.length ? (!complaint.authorizedRetailerCompanyId !== null && !isB2bComplaintForm) ? ('COMPLAINT|Przyjęcie zgłoszenia wymaga jednoznacznej identyfikacji zamówienia lub produktu (nr seryjny, nr zamówienia lub nr faktury zakupu), dla zakwalifikowania jako zgłoszenie reklamacyjne. Jeśli dane nie zostaną podane lub zostaną podane błędnie postaramy się odnaleźć zamówienie, jednak może to wydłużyć proces lub uniemożliwić przekazanie zgłoszenia do realizacji. W takiej sytuacji poinformujemy o tym w wiadomości email lub telefonicznie.' | translate) : ('COMPLAINT|Przyjęcie zgłoszenia wymaga jednoznacznej identyfikacji zamówienia lub produktu (nr seryjny lub nr zamówienia), dla zakwalifikowania jako zgłoszenie reklamacyjne. Jeśli dane nie zostaną podane lub zostaną podane błędnie, zgłoszenie nie zostanie przyjęte.' | translate) : ('COMPLAINT|Weryfikacja podanego numeru zostanie przeprowadzona po potwierdzeniu adresu email zgłaszającego' | translate)"
            ></icc-input>
            <icc-icon *ngIf="complaintPosition.complaintProductTypeId" name="info" (click)="openInfo('invoiceNumber')"></icc-icon>
        </div>
        <div *ngIf="showFields.orderPositionNumber && showFields.orderNumber" class="complaint-position__flex-container" [class.b2c-form]="b2cForm">
            <div *ngIf="showFields.orderPositionNumber" class="complaint-position__input">
                <icc-input
                    type="text"
                    [name]="'orderPositionNumber'"
                    [value]="complaintPosition.orderPositionNumber"
                    [size]="'medium'"
                    (valueChange)="complaintPosition.orderPositionNumber = $event"
                    [placeholder]="'COMPLAINT|Nr pozycji w zamówieniu' | translate"
                    [label]="'COMPLAINT|Nr pozycji w zamówieniu' | translate"
                    [prefixIcon]="'control'"
                    [maxLength]="4"
                ></icc-input>
                <icc-icon *ngIf="complaintPosition.complaintProductTypeId"></icc-icon>
            </div>
            <div *ngIf="showFields.orderNumber" class="complaint-position__input">
                <icc-input
                    type="text"
                    [name]="'orderNumber'"
                    [value]="complaintPosition.orderNumber"
                    [size]="'medium'"
                    (valueChange)="complaintPosition.orderNumber = $event"
                    [placeholder]="'COMPLAINT|Nr zamówienia' | translate"
                    [label]="'COMPLAINT|Nr zamówienia' | translate"
                    [prefixIcon]="'control'"
                    [supportText]="!complaintPosition.orderNumber?.length ? (complaint.authorizedRetailerCompanyId !== null && !isB2bComplaintForm) ? ('COMPLAINT|Przyjęcie zgłoszenia wymaga jednoznacznej identyfikacji zamówienia lub produktu (nr seryjny, nr zamówienia lub nr faktury zakupu), dla zakwalifikowania jako zgłoszenie reklamacyjne. Jeśli dane nie zostaną podane lub zostaną podane błędnie postaramy się odnaleźć zamówienie, jednak może to wydłużyć proces lub uniemożliwić przekazanie zgłoszenia do realizacji. W takiej sytuacji poinformujemy o tym w wiadomości email lub telefonicznie.' | translate) : ('COMPLAINT|Przyjęcie zgłoszenia wymaga jednoznacznej identyfikacji zamówienia lub produktu (nr seryjny lub nr zamówienia), dla zakwalifikowania jako zgłoszenie reklamacyjne. Jeśli dane nie zostaną podane lub zostaną podane błędnie, zgłoszenie nie zostanie przyjęte.' | translate) : ('COMPLAINT|Weryfikacja podanego numeru zostanie przeprowadzona po potwierdzeniu adresu email zgłaszającego' | translate)"
                ></icc-input>
                <icc-icon *ngIf="complaintPosition.complaintProductTypeId" name="info" (click)="openInfo('orderNumber')"></icc-icon>
            </div>
        </div>
        <div *ngIf="!b2cForm && getUserType() === 'manufacturer'" class="complaint-position__input">
            <icc-input
                type="text"
                [name]="'orderPositionNumber'"
                [value]="complaintPosition.distributorOrderNumber"
                [size]="'medium'"
                (valueChange)="complaintPosition.distributorOrderNumber = $event"
                [placeholder]="'COMPLAINT|Nr zamówienia pierwotnego (do producenta od dystrybutora)' | translate"
                [label]="'COMPLAINT|Nr zamówienia pierwotnego (do producenta od dystrybutora)' | translate"
                [disabled]="complaintPosition.complaintDocumentType === 'serialNumber' && complaintPosition.serialNumber?.length > 0"
            ></icc-input>
        </div>
        <div *ngIf="!b2cForm && getUserType() === 'manufacturer'" class="complaint-position__input">
            <icc-input
                type="text"
                [name]="'orderPositionNumber'"
                [value]="complaintPosition.distributorOrderPositionNumber"
                [size]="'medium'"
                (valueChange)="complaintPosition.distributorOrderPositionNumber = $event"
                [placeholder]="'COMPLAINT|Nr pozycji w zamówieniu do producenta od dystrybutora' | translate"
                [label]="'COMPLAINT|Nr pozycji w zamówieniu do producenta od dystrybutora' | translate"
                [disabled]="complaintPosition.complaintDocumentType === 'serialNumber' && complaintPosition.serialNumber?.length > 0"
            ></icc-input>
        </div>
        <div *ngIf="complaint.documentTypeId === documentTypes.complaint && complaintPosition.complaintProductTypeId" class="complaint-position__input">
            <icc-input
                type="date"
                [name]="'defectDate'"
                [value]="complaintPosition.defectDate"
                [size]="'medium'"
                [required]="true"
                (valueChange)="complaintPosition.defectDate = $event"
                [datePickerSide]="'left'"
                [min]="complaint.purchaseDate"
                [placeholder]="'COMPLAINT|Data zauważenia usterki' | translate"
                [label]="'COMPLAINT|Data zauważenia usterki' | translate"
                [dateErrorMessage]="'COMPLAINT|Wprowadź datę w formacie: dd.mm.rrrr' | translate"
            ></icc-input>
            <icc-icon *ngIf="complaintPosition.complaintProductTypeId"></icc-icon>
        </div>
        <icc-complaint-position-configuration-select
            *ngIf="complaintPosition.complaintProductTypeId"
            [first]="true"
            [(parent)]="complaintPosition.configuration"
            [parentOptions]="data.complaintCategories[complaintPosition.complaintProductTypeId]"
        ></icc-complaint-position-configuration-select>
        <div class="complaint-position__input" *ngIf="complaintPosition.complaintProductTypeId">
            <icc-input
                type="textarea"
                [name]="'description'"
                [value]="complaintPosition.description"
                [size]="'medium'"
                [required]="true"
                (valueChange)="complaintPosition.description = $event"
                [prefixIcon]="'edit'"
                [placeholder]="'COMPLAINT|Opis usterki' | translate"
                [label]="'COMPLAINT|Opis usterki' | translate"
                [supportText]="'COMPLAINT|Kliknij w ikonkę i po prawej stronie, aby sprawdzić jakie informacje na temat usterki są niezbędne do prawidłowego rozpatrzenia zgłoszenia.' | translate"
                [rows]="10"
                [inputLengthIsVisible]="true"
                [maxLength]="5000"
            ></icc-input>
            <icc-icon *ngIf="complaintPosition.complaintProductTypeId" name="info" (click)="openDescriptionInfo()"></icc-icon>
        </div>
        <div class="complaint-position__flex-container photos" [class.b2c-form]="b2cForm" *ngIf="complaintPosition.complaintProductTypeId">
            <div *ngIf="!closeUpPhotoPreview" class="complaint-position__input">
                <icc-input
                    type="file"
                    [name]="'closeUpPhoto' + complaintPosition.uuid"
                    [size]="'medium'"
                    [required]="true"
                    (valueChange)="onAddAttachment($event, 'closeUpPhoto')"
                    [prefixIcon]="'add_photo'"
                    [accept]="'image/jpeg, image/png'"
                    [placeholder]="('COMPLAINT|Zdjęcie usterki z bliska' | translate)"
                    [supportText]="complaintPosition.complaintProductTypeId ? ('COMPLAINT|Kliknij w ikonkę po prawej stronie, aby zobaczyć przykładowe zdjęcia z bliska oraz dowiedzieć się jakie cechy takie zdjęcie powinno mieć' | translate) : ('COMPLAINT|Najpierw wybierz typ produktu' | translate)"
                ></icc-input>
                <icc-icon *ngIf="complaintPosition.complaintProductTypeId" name="info" (click)="openInfo('closeUpPhoto')"></icc-icon>
            </div>
            <div *ngIf="closeUpPhotoPreview" class="details-card position-attachments">
                <div class="details-card-body">
                    <div class="image-container">
                        <img
                        [src]="closeUpPhotoPreview"
                        [alt]="'COMPLAINT|Zdjęcie usterki z bliska' | translate"
                        >
                    </div>
                    <div class="input">
                        <icc-input
                            type="text"
                            [name]="'closeUpPhotoDescription'"
                            [size]="'medium'"
                            [placeholder]="'COMPLAINT|Zdjęcie usterki z bliska' | translate"
                            [disabled]="true"
                        ></icc-input>
                    </div>
                    <div>
                        <icc-icon name="delete" (click)="removeAttachment('closeUpPhoto')"></icc-icon>
                    </div>
                </div>
            </div>
            <div *ngIf="!wholeProductPhotoPreview" class="complaint-position__input">
                <icc-input
                    type="file"
                    [name]="'wholeProductPhoto' + complaintPosition.uuid"
                    [size]="'medium'"
                    [required]="true"
                    (valueChange)="onAddAttachment($event, 'wholeProductPhoto')"
                    [prefixIcon]="'add_photo'"
                    [accept]="'image/jpeg, image/png'"
                    [placeholder]="getAttachment('wholeProductPhoto')?.name ?? 'COMPLAINT|Zdjęcie usterki na całym produkcie' | translate"
                    [supportText]="complaintPosition.complaintProductTypeId ? ('COMPLAINT|Kliknij w ikonkę po prawej stronie, aby zobaczyć przykładowe zdjęcia na całym produkcie oraz dowiedzieć się jakie cechy takie zdjęcie powinno mieć' | translate) : ('COMPLAINT|Najpierw wybierz typ produktu' | translate)"
                ></icc-input>
                <icc-icon *ngIf="complaintPosition.complaintProductTypeId" name="info" (click)="openInfo('wholeProductPhoto')"></icc-icon>
            </div>
            <div *ngIf="wholeProductPhotoPreview" class="details-card position-attachments">
                <div class="details-card-body">
                    <div class="image-container">
                        <img
                        [src]="wholeProductPhotoPreview"
                        [alt]="'COMPLAINT|Zdjęcie usterki na całym produkcie' | translate"
                        >
                    </div>
                    <div class="input">
                        <icc-input
                            type="text"
                            [name]="'wholeProductPhotoDescription'"
                            [size]="'medium'"
                            [placeholder]="'COMPLAINT|Zdjęcie usterki na całym produkcie' | translate"
                            [disabled]="true"
                        ></icc-input>
                    </div>
                    <div>
                        <icc-icon name="delete" (click)="removeAttachment('wholeProductPhoto')"></icc-icon>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="getAttachments('additionalPhoto').length > 0 || getAttachments('attachment').length > 0" class="complaint-position__additional-attachments" [class.b2c-form]="b2cForm">
            <div *ngIf="getAttachments('additionalPhoto') || getAttachments('attachment')" class="details-card position-attachments">
                <div class="details-card-body" *ngFor="let additionalAttachment of getAdditionalPhotosAndAttachments(); index as i">
                    <icc-icon [name]="getIconName(getAttachment(additionalAttachment.attachmentType, additionalAttachment.uuid)?.name)" [style]="{color: getIconColor(getAttachment(additionalAttachment.attachmentType, additionalAttachment.uuid)?.name)}"></icc-icon>
                    <div class="filename">
                        <span *ngIf="getAttachment(additionalAttachment.attachmentType, additionalAttachment.uuid)?.name" [title]="getAttachment(additionalAttachment.attachmentType, additionalAttachment.uuid)?.name">{{ getAttachment(additionalAttachment.attachmentType, additionalAttachment.uuid)?.name }}</span>
                    </div>
                    <div class="input">
                        <icc-input
                            type="text"
                            [name]="'additionalAttachmentDescription' + additionalAttachment.uuid"
                            [size]="'medium'"
                            [value]="getAttachment(additionalAttachment.attachmentType, additionalAttachment.uuid)?.description"
                            (valueChange)="getAttachment(additionalAttachment.attachmentType, additionalAttachment.uuid).description = $event"
                            [placeholder]="additionalAttachment.attachmentType === 'additionalPhoto' ? ('COMPLAINT|Zdjęcie #{i} - opcjonalny tytuł' | translate: {i: (i + 1)}) : ('COMPLAINT|Załącznik #{i} - opcjonalny tytuł' | translate: {i: (i + 1)})"
                        ></icc-input>
                    </div>
                    <div>
                        <icc-icon name="delete" (click)="removeAttachment(additionalAttachment.attachmentType, additionalAttachment.uuid)"></icc-icon>
                    </div>
                </div>
            </div>
        </div>
        <div class="complaint-position__buttons-container" *ngIf="complaintPosition.complaintProductTypeId">
            <div class="complaint-position__attachment">
                <label [for]="'additionalPhoto' + complaintPosition.uuid" style="cursor: pointer;">
                    <icc-icon name="add_photo"></icc-icon>{{ ('COMPLAINT|Dodatkowe zdjęcie' | translate) }}
                </label>
                <input
                    type="file"
                    accept="image/jpeg, image/png"
                    [id]="'additionalPhoto' + complaintPosition.uuid"
                    (change)="onAddAttachment($event.target.files, 'additionalPhoto')"
                >
            </div>
            <div class="complaint-position__attachment">
                <label [for]="'attachment' + complaintPosition.uuid" style="cursor: pointer;">
                    <icc-icon name="add"></icc-icon>{{ ('COMPLAINT|Dodaj załącznik' | translate) }}
                </label>
                <input
                    type="file"
                    accept="application/pdf, image/jpeg, image/png, application/msword"
                    [id]="'attachment' + complaintPosition.uuid"
                    (change)="onAddAttachment($event.target.files, 'attachment')"
                >
            </div>
        </div>
    </ng-container>
</div>
